// client/src/branding/icaros.ts
// Branding configuration for the Icaros Aviation tenant.

import type { TenantBranding } from './types';

export const icarosBranding: TenantBranding = {
  id: 'icaros',
  name: 'Icaros Aviation',
  appTitle: 'Icaros Aviation Academy',
  logo: '/branding/icaros/logo.png',
  favicon: '/branding/icaros/favicon.png',
  loginLogo: '/branding/icaros/logo.png',
  loginImage: '/branding/icaros/login-bg.jpg',
  loginTitle: 'Sistema de Gestión Académica con IA integrada',
  loginSubtitle: 'Plataforma para profesores, alumnos y personal administrativo',
  sidebarTitle: 'Icaros Aviation',
  footerText: 'Icaros Aviation Academy - Sistema de Gestión Académica',
  aiAssistantName: 'Icaro',
  domains: [
    'icaros.agoc-school.com',
    'icarosaviation.com',
    'app.icarosaviation.com',
    'localhost',
    'agoc-platform-dev.web.app',
    'agoc-platform-dev.firebaseapp.com',
    'agoc-school-test.web.app',
    'agoc-school-test.firebaseapp.com',
  ],
};
